import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef
} from '@angular/core';
import { Router } from '@angular/router';
import { DetailProductFunction } from '../detail-product.abstract.function';
import { EventManagerService } from '../../../blog/event-manager.service';
import { DashboardService } from '../../../dashboard/dashboard.service';
import { Constant } from '../../../blog/constant';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'detail-fund-popup',
  templateUrl: './detail-fund-popup.html',
  styleUrls: ['./detail-fund-popup.scss', './detail-fund-popup.responsive.scss']
})
export class DetailFundPopupComponent extends DetailProductFunction implements OnInit, OnChanges, OnDestroy {
  @Input() code: any;
  public override Constant = Constant;
  isDevice: any = false;
  isLoad: any = false;
  constructor(
    private cdref: ChangeDetectorRef,
    override eventManager: EventManagerService,
    override router: Router,
    private ngbModal: NgbModal,
    private translateService: TranslateService,
    override dashboardService: DashboardService,
  ) {
    super(eventManager, router, dashboardService);
  }

  override ngOnInit(): void {
    if (typeof window === 'undefined') {
      return;
    }
    super.ngOnInit();
    /* Scroll to active navbar tab */
    $(document).on('click', '.tab-scrollX .nav-link', function (e: any) {
      let tar = $(e.target).parents('li');
      let tarParent = tar.parents('ul');
      let x = tar.parents('body');
      tarParent.animate({
        scrollLeft: tar.offset().left + tarParent.scrollLeft() - x.width() / 1.5
      });
    });

    /* Scroll to active navbar tab mobile */
    $(document).on('click', '.tab-scrollX-mobile .nav-link', function (e: any) {
      let tar = $(e.target).parents('li');
      let tarParent = tar.parents('ul');
      let x = tar.parents('body');
      tarParent.animate({
        scrollLeft: tar.offset().left + tarParent.scrollLeft() - tarParent.width() / 2
      });
    });
    const language = localStorage.getItem('language') || '';
    this.translateService.use(language);
    setTimeout(() => {
      this.isLoad = true;
    }, 200);
  }

  ngAfterViewInit(): void {
    if (typeof window !== 'undefined') {
      this.isDevice = Constant.checkAndroid() || Constant.checkIOS();
    }
  }
  override ngOnChanges(simpleChanges: SimpleChanges) {
  }
  getDetailByCode() {
    if (!this.code) {
      return;
    }
    this.dashboardService.getProductByCode(this.code).subscribe(
      (res: any) => {
        this.product = res.data || {};
        this.isBond = this.product.dataFundAssetType.code === 'BOND';
        this.initData();
        this.cdref.detectChanges();
      },
      (error) => {}
    );
  }
  override dismiss() {
    this.ngbModal.dismissAll();
  }
}
